var exports = {
  "kL": "ThreadWelcomeSection.module__container___Z2N0X0",
  "Kk": "ThreadWelcomeSection.module__icon___Z2N0X0",
  "e5": "ThreadWelcomeSection.module__iconGlyph___Z2N0X0",
  "R_": "ThreadWelcomeSection.module__heading___Z2N0X0",
  "h_": "ThreadWelcomeSection.module__description___Z2N0X0",
};

module.exports = exports;
